import { useState, useCallback } from 'react';

export const useModal = () => {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  const hideModal = useCallback(() => {
    setIsModalShown(false);
  }, []);

  const showModal = useCallback(() => {
    setIsModalShown(true);
  }, []);

  return { isModalShown, showModal, hideModal };
};
